module.exports = __webpack_public_path__ + "static/media/fly0192.c8facdfb.webp";